import React, { FC } from "react";
import { Wizard } from "@evergis/ui";
import { useTranslation } from "react-i18next";

interface UploadWizardProps {
  currentStep?: number;
  disabledStep?: number;
}

export const UploadWizard: FC<UploadWizardProps> = ({ currentStep = 0, disabledStep = null }) => {
  const { t } = useTranslation("dialogs");

  return (
    <Wizard
      currentStep={currentStep}
      steps={[
        { label: t("uploadData.parameters"), disabled: disabledStep !== null },
        { label: t("uploadData.completeImport"), disabled: disabledStep === 1 },
      ]}
    />
  );
};
